var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_41855)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_41855)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9638 0.685074C16.0001 0.59421 16.009 0.494669 15.9894 0.398793C15.9697 0.302917 15.9223 0.214921 15.8531 0.145714C15.7839 0.0765079 15.6959 0.0291344 15.6001 0.00946694C15.5042 -0.0102005 15.4046 -0.00129702 15.3138 0.0350737L0.766773 5.85407H0.765773L0.313773 6.03407C0.228163 6.06822 0.153659 6.12537 0.0984888 6.1992C0.043319 6.27304 0.0096312 6.36068 0.00114666 6.45246C-0.00733788 6.54424 0.00971105 6.63658 0.0504102 6.71927C0.0911093 6.80197 0.153875 6.87181 0.231773 6.92107L0.641773 7.18107L0.642773 7.18307L5.63777 10.3611L8.81577 15.3561L8.81777 15.3581L9.07777 15.7681C9.1272 15.8457 9.19707 15.9081 9.27971 15.9486C9.36234 15.989 9.45453 16.0059 9.54613 15.9973C9.63773 15.9887 9.72519 15.955 9.79888 15.8999C9.87256 15.8448 9.92962 15.7705 9.96377 15.6851L15.9638 0.685074ZM14.1308 2.57507L14.6018 1.39707L13.4238 1.86807L5.92977 9.36207L6.26777 9.57707C6.3298 9.61647 6.38238 9.66905 6.42177 9.73107L6.63677 10.0691L14.1308 2.57507Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_41855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_41855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvite);
export default __webpack_public_path__ + "static/media/invite.dd4ac2af.svg";
export { ForwardRef as ReactComponent };